module.exports = __webpack_public_path__ + "img/suitcase.be5030ca.webp";